export default [
    {
        id: 1,
        level: 1,
        progress_coef: 0.166,
        name_ca: '1/6 - Esperant la firma del Supervisor Comercial',
        name_es: '1/6 - Esperando la firma del Supervisor Comercial',
        name_en: '1/6 - Waiting to be signed by the Commercial Supervisor'
    },
    {
        id: 2,
        level: 2,
        progress_coef: 0.333,
        name_ca: '2/6 - Firmat pel Supervisor Comercial, falta l\'aprovació del Supervisor Tècnic',
        name_es: '2/6 - Firmado por el Supervisor Comercial, falta la aprobación del Supervisor Técnico',
        name_en: '2/6 - Signed by the Commercial Supervisor, needs to be approved by the Technical Supervisor'
    },
    {
        id: 3,
        level: 3,
        progress_coef: 0.5,
        name_ca: '3/6 - Firmat, llest per enviar al client',
        name_es: '3/6 - Firmado, listo para enviar al cliente',
        name_en: '3/6 - Signed, ready to be sent to the client'
    },
    {
        id: 4,
        level: 4,
        progress_coef: 0.666,
        name_ca: '4/6 - Enviat al client, esperant la seva acceptació',
        name_es: '4/6 - Enviado al cliente, esperando su aceptación',
        name_en: '4/6 - Sent to client, waiting for acceptance'
    },
    {
        id: 5,
        level: 5,
        progress_coef: 0.833,
        name_ca: '5/6 - Acceptat pel client, falta el cobrament de la provisió de fons',
        name_es: '5/6 - Aceptado por el cliente, falta el cobro de la provisión de fondos',
        name_en: '5/6 - Accepted by client, waiting for provision funds'
    },
    {
        id: 6,
        level: 6,
        progress_coef: 1,
        name_ca: '6/6 - Acceptat i provisió de fons cobrada',
        name_es: '6/6 - Aceptado y provisión de fondos cobrada',
        name_en: '6/6 - Accepted and funds payed'
    }
]


// WEBPACK FOOTER //
// ./src/options/status_quotes.js